import Vue from 'vue'
import { Tooltip } from 'ant-design-vue'
import { calculateQantityPer } from '@/services/calculate'

Vue.use(Tooltip)

export default Vue.extend({
  template: `
      <span>
        <a-tooltip placement="right" :title="value ? parseFloat(value).toFixed(2) + ' %' :'0.00'">
          {{ value ? parseFloat(value).toFixed(2) + ' %' :'0.00' }}
        </a-tooltip>
      </span>`,
  data: function () {
    return {
      value: '',
      calculateQantityPer: calculateQantityPer,
    }
  },
  created() {
    if (this.params.data && (this.params.colDef.field === 'quantity_Percentage' || this.params.colDef.field === 'quantityPercentage')) {
      if (this.params.data.unit === 'SF') {
        const quantity = this.params.data.quantity ? this.params.data.quantity : 0
        this.value = calculateQantityPer(quantity, this.params.data.area)
      } else {
        this.value = null
      }
    } else {
      this.value = this.params.value
    }
  },
  methods: {
    getValue() {
      return this.value
    },
  },
})
